import { useSiteSettings } from "@/hooks/useSiteSettings";
import { useBusinessHours } from "@/hooks/useBusinessHours";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

export const ContactInfo = () => {
  const { settings } = useSiteSettings();
  const { formatted: hourLines } = useBusinessHours();
  return (
    <>
      <p>
        <strong className="text-foreground">Email:</strong> {settings.email}<br />
        <strong className="text-foreground">Phone:</strong> {settings.phone}<br />
        <strong className="text-foreground">Address:</strong> {settings.address}
      </p>
      {hourLines.length > 0 && (
        <p className="mt-3">
          <strong className="text-foreground">Hours:</strong><br />
          {hourLines.map((line) => (
            <span key={line.label} className="block">
              {line.label}: {line.isClosed ? "Closed" : line.value}
            </span>
          ))}
        </p>
      )}
    </>
  );
};

export const ContactBlock = () => {
  const { settings } = useSiteSettings();
  const { formatted: hourLines } = useBusinessHours();
  return (
    <div className="not-prose space-y-2 mt-3">
      <p className="flex items-center gap-2 text-sm text-muted-foreground">
        <Phone size={14} className="text-primary" /> {settings.phone}
      </p>
      <p className="flex items-center gap-2 text-sm text-muted-foreground">
        <Mail size={14} className="text-primary" /> {settings.email}
      </p>
      <p className="flex items-center gap-2 text-sm text-muted-foreground">
        <MapPin size={14} className="text-primary" /> {settings.address}
      </p>
      {hourLines.length > 0 && (
        <div className="flex items-start gap-2 text-sm text-muted-foreground pt-1">
          <Clock size={14} className="text-primary mt-0.5 flex-shrink-0" />
          <div className="space-y-0.5">
            {hourLines.map((line) => (
              <div key={line.label}>
                <span className="text-foreground/80">{line.label}:</span>{" "}
                {line.isClosed ? <span className="italic">Closed</span> : line.value}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
